import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationModuleDTO } from '../../models/application-module/application-module';

@Injectable({
  providedIn: 'root'
})
export class ApplicationModuleService {
  endpoint = `${environment.apiUrl}/api/application-modules`;

  constructor(private readonly http: HttpClient) {}

  getByUserId(userId: string): Observable<ApplicationModuleDTO[]> {
    return this.http.get<ApplicationModuleDTO[]>(this.endpoint + '/' + userId);
  }
}
